import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Market Discovery",
    text: "We map demand, competition, and entry barriers to identify where your offer wins first.",
  },
  {
    num: "02",
    title: "Strategy & Compliance",
    text: "A practical entry plan covering positioning, pricing, regulations, and documentation.",
  },
  {
    num: "03",
    title: "Partner Matchmaking",
    text: "Vetted introductions to buyers, suppliers, and distributors with genuine commercial intent.",
  },
  {
    num: "04",
    title: "Market Execution",
    text: "Representation, negotiation support, and follow-through until the opportunity becomes revenue.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative bg-royal py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold sm:text-xs">Why choose us</p>
        <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
          A clear path from opportunity to execution.
        </h2>
      </motion.div>

      <div className="relative mt-20">
        <div className="absolute left-6 top-0 h-full w-px bg-gradient-to-b from-gold/60 via-gold/25 to-transparent lg:left-0 lg:top-6 lg:h-px lg:w-full lg:bg-gradient-to-r" />
        <div className="grid gap-14 lg:grid-cols-4 lg:gap-8">
          {STEPS.map(({ num, title, text }, i) => (
            <motion.div
              key={num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.14, duration: 0.75, ease: [0.16, 1, 0.3, 1] }}
              className="relative pl-16 lg:pl-0 lg:pt-16"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-full border border-gold/50 bg-royal-deep font-mono text-sm font-semibold text-gold lg:left-0">
                {num}
              </div>
              <h3 className="font-serif text-xl font-semibold text-white">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
